export enum ErrorStateType {
  AccessDenied = "accessDenied",
  Forbidden = "forbidden",
  Generic = "generic",
}

// Generic error (network/server failures)
export const PWI_ERROR_HEADER = "Sorry, something went wrong";
export const PWI_ERROR_CONTENT =
  "We were unable to retrieve your data. Please try again or come back later. We apologize for the inconvenience.";

// Access denied — shown for secondary POIDs and trust/org POIDs
export const ACCESS_DENIED_ERROR_HEADER = "This page is unavailable";
export const ACCESS_DENIED_ERROR_CONTENT =
  "This resource can only be accessed through the Primary Client in the Advice Relationship.";

// Self-directed client forbidden error
export const FORBIDDEN_ERROR_CONTENT = "You do not have permission to access this resource.";

// F&R specific generic error
export const FR_ERROR_HEADER = "There was a communication error";
export const FR_ERROR_CONTENT =
  "There was a temporary error loading your account information. Please try again later.";
export const EXIT_FAMILY_TREE_BUTTON = "Exit family tree";
